import { render, staticRenderFns } from "./AdditionalOrderScreen.vue?vue&type=template&id=0282e1e6&scoped=true&"
import script from "./AdditionalOrderScreen.vue?vue&type=script&lang=js&"
export * from "./AdditionalOrderScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282e1e6",
  null
  
)

export default component.exports